import { Theme } from "@mui/material";

export default (theme: Theme) => ({
  width: "100%",
  [theme.breakpoints.up("lg")]: {
    flexDirection: "row",
    gap: "calc(2 * var(--rhythm))",
  },
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    gap: "var(--rhythm)",
  },
});
